class CategoryItemComponent extends HTMLElement {
  constructor() {
    super()
    const shadow = this.attachShadow({ mode: 'open' })
    const text = this.getAttribute('text')
    const type = this.getAttribute('type')
    const href = this.getAttribute('href')
    shadow.innerHTML = `
      <a class="category-item ${type}" href="${href || ''}">
        <div class="category-item__content">
          <img src="//decxtf-gg.myshopify.com/cdn/shop/t/4/assets/icon-star.svg" alt="" width="50" height="50">
          <div class="category-item__content--text">${text}</div>
        </div>
        <div class="category-item__icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.6664 6.0915L7.20457 1.62966L8.33594 0.498291L13.9292 6.0915L8.33594 11.6847L7.20457 10.5533L11.6664 6.0915Z" fill="#5C5D5E"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.8 6.9031L0 6.89333L0.0012207 5.29333L12.8013 5.3031L12.8 6.9031Z" fill="#5C5D5E"/>
          </svg>
        </div>
      </a>
    `
    const style = document.createElement('style')
    style.textContent = `
      a {
          text-decoration: none;
        }
        .category-item {
          width: 273px;
          height: 80px;
          padding: 12px 16px;
          background-color: #F6F7FA;
          display: flex;
          align-items: center;
          box-sizing: content-box;
          color: #262728;
          justify-content: space-between;
        }
        .category-item.third {
          width: 271px;
          height: 50px;
          background-color: #fff;
          border: 1px solid #ddd;
        }

        .category-item.third:hover {
          background-color: #1552E0;
          border-radius: 6px;
          box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.25);
        }

        .category-item__content {
          display: flex;
          gap: 16px;
          align-items: center;
        }

        .category-item__content--text {
          font-size: 16px;
          display: flex;
          align-items: center;
        }

        .category-item__icon {
          width: 16px;
          height: 16px;
        }

        .category-item:hover {
          background-color: #1552E0;
          border-radius: 6px;
          color: #fff;
          cursor: pointer;
        }

        .category-item:hover .category-item__icon svg path {
          stroke: #fff;
        }
      `
    shadow.appendChild(style)
  }
}
customElements.define('category-item-component', CategoryItemComponent)

class ProductItemComponent extends HTMLElement {
  constructor() {
    super()
    const shadow = this.attachShadow({ mode: 'open' })
    const sku = this.getAttribute('sku')
    const title = this.getAttribute('title')
    const img = this.getAttribute('img')
    const href = this.getAttribute('href')
    const productId = this.getAttribute('productId')
    shadow.innerHTML = `
      <div class="good">
        <div class="good__top">
          <img src="${img}" alt="" width="100%">
          <a class="good__top__btn" href="${href || ''}">Quick View</a>
        </div>
        <div class="good__content">
          <div class="good__content__name">
            ${sku}
          </div>
          <div class="good__content__desc">
            ${title}
          </div>
        </div>
        <div class="good__bottom">
          <div class="good__bottom__right cart">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M1.71603 1.80005C1.32597 1.80005 1.00977 2.11626 1.00977 2.50632L1.01573 2.59857L1.01621 2.60209C1.06298 2.94687 1.35843 3.21258 1.71603 3.21258H3.74234L5.32683 12.327C5.08203 12.605 4.93347 12.97 4.93347 13.3695C4.93347 14.2411 5.64006 14.9477 6.51167 14.9477H17.4109C17.8009 14.9477 18.1171 14.6315 18.1171 14.2415C18.1171 13.8514 17.8009 13.5352 17.4109 13.5352H6.51167C6.42018 13.5352 6.34601 13.461 6.34601 13.3695C6.34601 13.278 6.42018 13.204 6.51167 13.204L6.62351 13.195L17.091 11.4504C17.3769 11.4027 17.6047 11.1852 17.6655 10.9017L18.9734 4.39817C19.0676 3.95851 18.7324 3.54392 18.2828 3.54392H5.23834L5.02671 2.37997C4.96565 2.04415 4.67317 1.80005 4.33184 1.80005H1.71603ZM6.65888 11.7569L5.49516 4.95645H17.4089L16.3845 10.136L6.65888 11.7569Z" fill="white"/>
              <path d="M6.94764 15.9156C6.3168 15.9156 5.80541 16.427 5.80541 17.0578C5.80541 17.6887 6.3168 18.2 6.94764 18.2C7.57848 18.2 8.08988 17.6887 8.08988 17.0578C8.08988 16.427 7.57848 15.9156 6.94764 15.9156Z" fill="white"/>
              <path d="M15.667 15.9156C15.0361 15.9156 14.5248 16.427 14.5248 17.0578C14.5248 17.6887 15.0361 18.2 15.667 18.2C16.2978 18.2 16.8092 17.6887 16.8092 17.0578C16.8092 16.427 16.2978 15.9156 15.667 15.9156Z" fill="white"/>
              ${
                !getProductById(productId)
                  ? `<path d="M11.5002 5.80005C11.7833 5.80005 12.031 6.04774 12.031 6.33082V7.56928H13.2694C13.5525 7.56928 13.8002 7.81697 13.8002 8.10005C13.8002 8.38313 13.5525 8.63082 13.2694 8.63082H12.031V9.86928C12.031 10.1524 11.7833 10.4 11.5002 10.4C11.2171 10.4 10.9694 10.1524 10.9694 9.86928V8.63082H9.73096C9.44789 8.63082 9.2002 8.38313 9.2002 8.10005C9.2002 7.81697 9.44789 7.56928 9.73096 7.56928H10.9694V6.33082C10.9694 6.04774 11.2171 5.80005 11.5002 5.80005Z" fill="white"/>`
                  : ''
              }
            </svg>
            ${
              getProductById(productId)
                ? `<span class="checked"> ✔ </span>`
                : ''
            }
          </div>
        </div>
      </div>
    `
    const style = document.createElement('style')
    style.textContent = `
      .good {
        padding: 10px;
        width: 240px;
      }

      .good:hover {
        cursor: pointer;
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.10);
      }

      .good__top {
        position: relative;
        height: 220px;
        margin-bottom: 10px;
        overflow: hidden;
      }

      .good__top__return {
        position: absolute;
        top: 10px;
        left: 0;
        background-color: #165ee3;
        color: #fff;
        padding: 3px 6px;
      }

      .good__top__btn {
        text-decoration:none;
        display:block;
        position: absolute;
        margin: auto;
        width: 95%;
        background-color: rgba(38, 39, 40, 0.96);
        color: #fff;
        padding: 3px 6px;
        text-align: center;
        bottom: 0;
        transform: translate(0, 35px);
        transition: 0.3s;
      }

      .good:hover .good__top__btn {
        transform: translate(0, -10px);
      }

      .good__content {
        margin-bottom: 10px;
        color: #262728;
      }

      .good__content__name {
        font-weight: 600;
        font-size: 14px;
      }

      .good__content__desc {
        font-size: 14px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }

      .good__bottom {
        display: flex;
        justify-content: end;
        align-items: center;
        font-size: 12px;
      }

      .good__bottom__left {
        color: #5c5d5e;
        background-color: #f6f7f8;
        padding: 0 6px;
      }

      .good__bottom__left span {
        color: #262728;
        font-weight: 450;
      }

      .good__bottom__right {
        width:38px;
        height: 38px;
        background-color: #262728;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        position:relative;
      }
      .good__bottom__right:hover{
         background-color: #1552E0;
      }
      .good__bottom__right .checked {
        position:absolute;
        color:#fff;
        padding:0px 3px;
        background:red;
        display:block;
        right:-5px;
        top:-5px;
        border-radius:50%;
        font-size:9px;
      }
    `
    shadow.appendChild(style)
  }
  connectedCallback() {
    this.productId = this.getAttribute('productId')
    this.sku = this.getAttribute('sku')
    this.title = this.getAttribute('title')
    this.img = this.getAttribute('img')
    const button = this.shadowRoot.querySelector('.cart')
    button.addEventListener('click', this.addCart.bind(this))
  }
  addCart() {
    const isExist = getProductById(this.productId)
    const button = this.shadowRoot.querySelector('.cart')
    if (!isExist) {
      addToCart({
        title: this.title,
        sku: this.sku,
        img: this.img,
        productId: this.productId,
      })
    } else {
      delProductById(this.productId)
    }
    button.innerHTML = `
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.71603 1.80005C1.32597 1.80005 1.00977 2.11626 1.00977 2.50632L1.01573 2.59857L1.01621 2.60209C1.06298 2.94687 1.35843 3.21258 1.71603 3.21258H3.74234L5.32683 12.327C5.08203 12.605 4.93347 12.97 4.93347 13.3695C4.93347 14.2411 5.64006 14.9477 6.51167 14.9477H17.4109C17.8009 14.9477 18.1171 14.6315 18.1171 14.2415C18.1171 13.8514 17.8009 13.5352 17.4109 13.5352H6.51167C6.42018 13.5352 6.34601 13.461 6.34601 13.3695C6.34601 13.278 6.42018 13.204 6.51167 13.204L6.62351 13.195L17.091 11.4504C17.3769 11.4027 17.6047 11.1852 17.6655 10.9017L18.9734 4.39817C19.0676 3.95851 18.7324 3.54392 18.2828 3.54392H5.23834L5.02671 2.37997C4.96565 2.04415 4.67317 1.80005 4.33184 1.80005H1.71603ZM6.65888 11.7569L5.49516 4.95645H17.4089L16.3845 10.136L6.65888 11.7569Z" fill="white"/>
        <path d="M6.94764 15.9156C6.3168 15.9156 5.80541 16.427 5.80541 17.0578C5.80541 17.6887 6.3168 18.2 6.94764 18.2C7.57848 18.2 8.08988 17.6887 8.08988 17.0578C8.08988 16.427 7.57848 15.9156 6.94764 15.9156Z" fill="white"/>
        <path d="M15.667 15.9156C15.0361 15.9156 14.5248 16.427 14.5248 17.0578C14.5248 17.6887 15.0361 18.2 15.667 18.2C16.2978 18.2 16.8092 17.6887 16.8092 17.0578C16.8092 16.427 16.2978 15.9156 15.667 15.9156Z" fill="white"/>
        ${
          !isExist
            ? ''
            : '<path d="M11.5002 5.80005C11.7833 5.80005 12.031 6.04774 12.031 6.33082V7.56928H13.2694C13.5525 7.56928 13.8002 7.81697 13.8002 8.10005C13.8002 8.38313 13.5525 8.63082 13.2694 8.63082H12.031V9.86928C12.031 10.1524 11.7833 10.4 11.5002 10.4C11.2171 10.4 10.9694 10.1524 10.9694 9.86928V8.63082H9.73096C9.44789 8.63082 9.2002 8.38313 9.2002 8.10005C9.2002 7.81697 9.44789 7.56928 9.73096 7.56928H10.9694V6.33082C10.9694 6.04774 11.2171 5.80005 11.5002 5.80005Z" fill="white"/>'
        }
      </svg>
      ${!isExist ? '<span span class="checked" >✔</span>' : ''}
    `
  }
}
customElements.define('product-item-component', ProductItemComponent)

class PaginationComponent extends HTMLElement {
  constructor() {
    super()
    this.attachShadow({ mode: 'open' })
    this.total = 150
    this.limit = 30
    this.current = 1
  }
  connectedCallback() {
    this.shadowRoot.innerHTML = `
     <div class="pagination">
      <div>Showing 1-30 of 147 Products</div>
      <div class="page">
        <div class="prev page__item">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.6255 14.4595C11.9022 14.1829 11.9022 13.7344 11.6255 13.4578L7.40419 9.23644L11.6255 5.01508C11.9022 4.73846 11.9022 4.28997 11.6255 4.01335C11.3489 3.73673 10.9004 3.73673 10.6238 4.01335L5.90158 8.73557C5.76875 8.86841 5.69412 9.04858 5.69412 9.23644C5.69412 9.4243 5.76875 9.60447 5.90158 9.7373L10.6238 14.4595C10.9004 14.7361 11.3489 14.7361 11.6255 14.4595Z" fill="#929393"/>
          </svg>
        </div>
        <div class="number page__item active">1</div>
        <div class="number page__item">2</div>
        <div class="number page__item">3</div>
        <div class="number page__item">4</div>
        <div class="number page__item">5</div>
        <div class="number page__item">6</div>
        <div class="number page__item">7</div>
        <div class="next page__item">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.37446 14.4595C6.09784 14.1829 6.09784 13.7344 6.37446 13.4578L10.5958 9.23644L6.37446 5.01508C6.09784 4.73846 6.09784 4.28997 6.37446 4.01335C6.65108 3.73673 7.09957 3.73673 7.37619 4.01335L12.0984 8.73557C12.2313 8.86841 12.3059 9.04858 12.3059 9.23644C12.3059 9.4243 12.2313 9.60447 12.0984 9.7373L7.37619 14.4595C7.09957 14.7361 6.65108 14.7361 6.37446 14.4595Z" fill="#5C5D5E"/>
          </svg>
        </div>
      </div>
    </div>
    `
    const style = document.createElement('style')
    style.textContent = `
      .pagination {
        margin-top: 20px;
        display: flex;
        justify-content: space-between;
      }
      .page {
        display: flex;
        gap: 14px;
      }
      .page__item {
        width: 28px;
        height: 28px;
        border: 1px solid #d6d7d8;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
      .page__item.number.active {
        background-color: #1552e0;
        color: #fff;
        border: none;
      }
    `
    this.shadowRoot.appendChild(style)
    const page = this.shadowRoot.querySelector('.page')
    page.addEventListener('click', this.handleClick.bind(this, page))
  }

  attributeChangedCallback(name, oldValue, newValue) {
    console.log(name, oldValue, newValue)
  }

  handleClick(page, e) {
    if (e.target.classList.contains('active')) return
    if (e.target.classList.contains('number')) {
      for (let item of page.children) {
        if (item !== e.target) {
          item.classList.remove('active')
        }
      }
      e.target.classList.add('active')
      this.current = e.target.textContent
      this.dispatchEvent(
        new CustomEvent('pageChange', {
          detail: {
            current: this.current,
          },
        })
      )
    }
  }
}
customElements.define('pagination-component', PaginationComponent)

class SimplePaginationComponent extends HTMLElement {
  constructor() {
    super()
    this.attachShadow({ mode: 'open' })
  }
  connectedCallback() {
    this.shadowRoot.innerHTML = `
     <div class="pagination">
      <div class="prev pagination__item">
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 18 18" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M11.6255 14.4595C11.9022 14.1829 11.9022 13.7344 11.6255 13.4578L7.40419 9.23644L11.6255 5.01508C11.9022 4.73846 11.9022 4.28997 11.6255 4.01335C11.3489 3.73673 10.9004 3.73673 10.6238 4.01335L5.90158 8.73557C5.76875 8.86841 5.69412 9.04858 5.69412 9.23644C5.69412 9.4243 5.76875 9.60447 5.90158 9.7373L10.6238 14.4595C10.9004 14.7361 11.3489 14.7361 11.6255 14.4595Z" fill="#5C5D5E"/>
        </svg>
      </div>
      <div class="next pagination__item">
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 18 18" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M6.37446 14.4595C6.09784 14.1829 6.09784 13.7344 6.37446 13.4578L10.5958 9.23644L6.37446 5.01508C6.09784 4.73846 6.09784 4.28997 6.37446 4.01335C6.65108 3.73673 7.09957 3.73673 7.37619 4.01335L12.0984 8.73557C12.2313 8.86841 12.3059 9.04858 12.3059 9.23644C12.3059 9.4243 12.2313 9.60447 12.0984 9.7373L7.37619 14.4595C7.09957 14.7361 6.65108 14.7361 6.37446 14.4595Z" fill="#5C5D5E"/>
        </svg>
      </div>
    </div>
    `
    const style = document.createElement('style')
    style.textContent = `
      .pagination{
        display: flex;
        gap: 15px;
      }
      .pagination__item{
        width:26px;
        height: 26px;
        border: 1px solid #D6D7D8;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .pagination__item:not(.disabled):hover{
        cursor: pointer;
      }
      .pagination__item:not(.disabled):hover svg path{
        fill:#1552E0;
      }
      .pagination__item.disabled{
        cursor:not-allowed;
      }
      .pagination__item.disabled svg path{
        fill:#929393 ;
      }
      svg{
        pointer-events:none;
      }
    `
    this.shadowRoot.appendChild(style)
    const pagination = this.shadowRoot.querySelector('.pagination')
    pagination.addEventListener('click', this.handleClick.bind(this))
  }

  attributeChangedCallback(name, oldValue, newValue) {
    console.log(name, oldValue, newValue)
  }

  handleClick(e) {
    if (
      !e.target.classList.contains('pagination__item') ||
      e.target.classList.contains('disabled')
    )
      return
    this.dispatchEvent(
      new CustomEvent('pageChange', {
        detail: {
          value: e.target.classList[0],
          setDisabled: this.setDisabled,
        },
      })
    )
  }
  setDisabled = (key, disabled) => {
    const dom = this.shadowRoot.querySelector(`.pagination__item.${key}`)
    dom.classList[disabled ? 'add' : 'remove']('disabled')
  }
}
customElements.define('simple-pagination-component', SimplePaginationComponent)

class CheckboxGroup extends HTMLElement {
  static observedAttributes = ['data']
  constructor() {
    super()
    this.attachShadow({ mode: 'open' })
    this.result = []
  }
  connectedCallback() {
    this.multipled = this.getAttribute('multipled')
    this.shadowRoot.innerHTML = `
      <div class="checkbox-group"></div>
    `
    const style = document.createElement('style')
    style.textContent = `
      .my-checkbox {
        display: flex;
        align-items: center;
        gap: 10px;
      }
      .my-checkbox input[type='checkbox'] {
        width: 16px;
        height: 16px;
        cursor: pointer;
        margin: 0;
      }
      .my-checkbox label {
        color: #5c5d5e;
        cursor: pointer;
        font-size: 14px;
      }
    `
    this.shadowRoot.appendChild(style)
    this.shadowRoot
      .querySelector('.checkbox-group')
      .addEventListener('change', this.handleChange)
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data') {
      const group = this.shadowRoot.querySelector('.checkbox-group')
      group.innerHTML = ''
      JSON.parse(newValue).forEach((item) => {
        group.innerHTML += `
          <div class="my-checkbox">
            <input type="checkbox" id="${item.key}">
            <label for="${item.key}">${item.name}</label>
          </div>
        `
      })
    }
  }
  handleChange = (e) => {
    const children = Array.from(
      this.shadowRoot.querySelector('.checkbox-group').children
    )
    if (this.multipled === 'false') {
      children.forEach((ele) => {
        if (ele.children[0] !== e.target) {
          ele.style.display = e.target.checked ? 'none' : 'block'
          ele.children[0].disabled = e.target.checked
        }
      })
    }
    const index = this.result.indexOf(e.target.id)
    if (index == -1) {
      this.result.push(e.target.id)
    } else {
      this.result.splice(index, 1)
    }
    this.dispatchEvent(
      new CustomEvent('change', {
        detail: {
          result: this.result,
        },
      })
    )
  }
}

customElements.define('checkbox-group', CheckboxGroup)
